import { useCallback } from "react";
import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana37Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandById = (id) => {
    return lands.filter((l) => l.id === id)[0];
  };
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };
  const getFill = useCallback(
    (id, selected2) => {
      const land = lands.find((l) => l.id === id);
      const disabledColor = "#6F8789";
      const normalColor = "#0096B3";
      const selectedColor = "#5AE5F4";

      if (!land) {
        return disabledColor; // disabled
      }

      if (selected) {
        if (id === selected.id) {
          return selectedColor;
        }
      }

      if (land.status !== "on_sale") {
        return disabledColor; // disabled
      } else {
        return normalColor; // normal color
      }
    },
    [lands, selected]
  );

  if (!lands) {
    return <></>;
  }

  return (
    <svg
      width={style?.width || "1219"}
      height={style?.height || "941"}
      viewBox="0 0 1221 921"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="1221" height="921" fill="url(#pattern0_1468_42594)" />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("17"))}
        d="M507.301 283.989L514.946 316.097L455.317 332.915L443.086 285.518C451.75 283.479 472.441 278.485 485.896 274.816C499.351 271.146 505.772 279.403 507.301 283.989Z"
        fill={getFillByLot(17, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("1"))}
        d="M395.688 296.22L443.085 285.518L453.788 329.857L394.16 346.675L386.515 316.096C384.069 302.642 391.611 297.239 395.688 296.22Z"
        fill={getFillByLot(1, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("16"))}
        d="M527.174 363.493L514.943 316.096L455.314 332.914L467.546 380.311L527.174 363.493Z"
        fill={getFillByLot(16, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("2"))}
        d="M404.861 392.544L394.158 346.676L453.787 329.857L466.018 374.196L404.861 392.544Z"
        fill={getFillByLot(2, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("15"))}
        d="M539.413 407.833L527.181 363.494L467.553 380.312L481.313 424.651L539.413 407.833Z"
        fill={getFillByLot(15, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("3"))}
        d="M417.093 436.884L404.861 392.545L466.019 374.198L478.25 417.008L417.093 436.884Z"
        fill={getFillByLot(3, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("4"))}
        d="M432.385 481.222L417.096 436.882L478.253 417.006L492.013 461.345L432.385 481.222Z"
        fill={getFillByLot(4, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("14"))}
        d="M553.168 452.172L539.408 407.833L481.309 424.651L495.069 472.048L553.168 452.172Z"
        fill={getFillByLot(14, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("13"))}
        d="M568.465 498.039L553.176 452.171L495.076 472.047L511.894 516.386L568.465 498.039Z"
        fill={getFillByLot(13, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("5"))}
        d="M447.674 527.088L432.385 481.22L492.013 461.344L507.302 504.154L447.674 527.088Z"
        fill={getFillByLot(5, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("6"))}
        d="M462.965 569.899L447.676 527.089L507.304 504.155L522.593 546.965L462.965 569.899Z"
        fill={getFillByLot(6, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("12"))}
        d="M583.747 540.846L568.457 498.036L511.887 517.912L528.705 562.251L583.747 540.846Z"
        fill={getFillByLot(12, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("7"))}
        d="M479.783 614.236L462.965 569.897L522.593 546.963L539.411 589.773L479.783 614.236Z"
        fill={getFillByLot(7, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("11"))}
        d="M602.1 585.189L583.752 540.85L528.711 562.255L545.529 608.123L602.1 585.189Z"
        fill={getFillByLot(11, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("8"))}
        d="M482.831 621.882L479.773 614.237L539.402 589.774L568.452 663.163L482.831 621.882Z"
        fill={getFillByLot(8, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("10"))}
        d="M618.913 628L602.094 585.19L547.053 608.124L563.871 650.934L618.913 628Z"
        fill={getFillByLot(10, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("9"))}
        d="M640.318 673.867L618.913 627.999L563.871 650.933L568.458 663.164L621.971 692.214C642.764 697.107 642.866 682.021 640.318 673.867Z"
        fill={getFillByLot(9, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <defs>
        <pattern
          id="pattern0_1468_42594"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_1468_42594"
            transform="matrix(0.00209719 0 0 0.00278031 -2.95293 -0.872594)"
          />
        </pattern>
        <image
          id="image0_1468_42594"
          width="4096"
          height="2304"
          href="/mz2.png"
        />
      </defs>
    </svg>
  );
};
